import { Close } from '@watersport/ui-react-icons'
import { Button } from '@watersport/ui-react-next'
import React from 'react'

import { cn } from 'features/common/helpers/cn'

export interface ConfirmLocationButtonProps {
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmLocationButton: React.FC<ConfirmLocationButtonProps> = ({ onConfirm, onCancel }) => {
  return (
    <>
      <div className="flex items-center justify-center">
        <Button
          containerClassName="w-[194px]"
          variant={'default'}
          text={'Confirm location'}
          rounded
          size={'xl'}
          onClick={onConfirm}
          data-testid="confirm-button"
        />
      </div>
      <div className="flex items-center justify-center">
        <Button
          containerClassName="w-[52px] h-[52px]"
          className={cn('rounded-lg shadow-md cursor-pointer hover:bg-blue-600')}
          variant={'default'}
          text={<Close width={24} height={24} />}
          onClick={onCancel}
          data-testid="cancel-button"
        />
      </div>
    </>
  )
}

export default ConfirmLocationButton
